/* The photograph inside the auth pane. The pane's own box, padding and graded plate are
 * `AuthShell.module.css`'s and nothing is declared on both sides.
 *
 * This is NOT `photoBox.module.css`. That file's job is to reserve a box and stand a neutral ground
 * in it while a NETWORK image decodes; these are bundled assets behind a plate that is already
 * painted (`--photo`), in a pane whose size comes from the grid and cannot move whatever happens to
 * the file. What would be borrowed is one `object-fit` declaration, and borrowing it would put a
 * second ground underneath a plate that is already the ground.
 *
 * `--photo-filter` is KANON's documentary grade and it sits HERE rather than on the pane, for the
 * reason the pseudo-element it replaced carried: `filter` on `.photo` would grade the tag and the
 * headline with it, and desaturating type is not what that token is for. */
.image {
  position: absolute;
  inset: var(--space-0);
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: var(--photo-filter);
}
